<template>
<div id="game" class="game">
  <div class="top-ad">
    <div class="ad-content">
      <div class="ad-title">
        <img class="title" :src="maxs[tab].src" alt="">
        <div class="sub-title" v-if="stopDrawTime!=='end' && guessTime[tab].time !== 'end'">{{formatTime}}</div>
        <div class="sub-title" v-else-if="stopDrawTime==='end' && guessTime[tab].time !== 'end'">本轮竞猜已截止</div>
        <div class="sub-title" v-else-if="guessTime[tab].time === 'end'">{{maxs[tab].text}}万元竞猜已开奖</div>
      </div>
      <div class="time" v-if="stopDrawTime!=='end' && guessTime[tab].time !== 'end'">距离竞猜截止：{{stopDrawTime}}</div>
      <!-- <div class="time" v-else-if="stopDrawTime==='end' && guessTime[tab].time !== 'end'">开奖时间：{{openTimes[tab].replace('/','年').replace('/','月').replace(' ','日')}}</div> -->
      <div class="time" v-else-if="stopDrawTime==='end' && guessTime[tab].time !== 'end'">距离开奖时间：{{guessTime[tab].time}}</div>
      <div class="time" v-else-if="guessTime[tab].time === 'end'">共有<span>{{$state.drawResult[maxs[tab].key].num}}</span>人猜中</div>
    </div>
    <button class="talk-btn" type="button" name="button" @click="talkClick"></button>
    <button class="bill-btn" type="button" name="button" @click="uploadBill">上传发票</button>
  </div>
  <div class="lottery-area">
    <div class="tab">
      <div class="item" v-for="(item,index) in guessTime" :class="tab===index?'active':''" @click="tabClick(item,index)">
        {{item.name}}
      </div>
    </div>
    <div class="box">
      <div class="list" v-if="guessTime[tab].time !== 'end'">
        <scroll ref="scroll">
          <div class="teams">
            <div class="team" v-for="(item,index) in $state.teams[maxs[tab].key].list" @click="teamsClick(item,index)">
              <div class="info">
                <div class="image">
                  <img :src="item.img" alt="" />
                </div>
                <span>{{item.name}}</span>
              </div>
              <button class="choose" v-if="activeList.indexOf(item.id)<0" type="button" name="button">{{stopDrawTime==='end'?'已截止':'选择它'}}</button>
              <button class="choose got" v-else type="button" name="button">已选择</button>
              <div class="num">已支持:{{item.num}}</div>
            </div>
          </div>
        </scroll>
      </div>
      <div class="lottery-result" v-else>
        <scroll ref="scroll">
          <div v-if="$state.drawResult[maxs[tab].key].total > 0" class="result-area">
            <div v-if = "$state.drawResult[maxs[tab].key].money">
              <div class="lottery-title">恭喜你</div>
              <div class="lottery-text">猜中<span>{{tab == 2 ? '冠军队伍':`${$state.drawResult[maxs[tab].key].total}支`}}</span>{{tab != 2 ?'队伍':'' }}，瓜分得<span>{{$state.drawResult[maxs[tab].key].money}}</span>元</div>
              <button class="choose" v-if="!$state.drawResult[maxs[tab].key].status" type="button" name="button" @click="getMoney(maxs[tab].key)">立即领取</button>
              <div v-else>
                <button class="choose got"   type="button" name="button">已领取</button>
                <div class="lottery-tip">（现金将于24h内到账余额）</div>
              </div>
            </div>
            <div v-else class="no-lottery">
              猜中<span>{{tab == 2 ? '冠军队伍':`${$state.drawResult[maxs[tab].key].total}支`}}</span>{{tab != 2 ?'队伍':'' }}，{{$state.drawResult[maxs[tab].key].tips}}
            </div>
          </div>
          <div v-else class="no-lottery">
            很遗憾<br />你没有猜中~
          </div>
          <div class="top_1" v-if="tab == 2 && $state.drawResult[maxs[tab].key].winners.length === 1">
            <div v-for="(item,index) in $state.drawResult[maxs[tab].key].winners">
              <div class="top1-title">冠军队伍:</div>
              <div class="top1-img">
                <img :src="item.img" alt="">
              </div>
              <div class="top1-name">{{item.name}}</div>
            </div>
          </div>
          <div class="top" v-else>
            <div class="top-items_title">{{maxs[tab].num}}强队伍:</div>
            <div class="top-items_list">
              <div class="item" v-for="(item,index) in $state.drawResult[maxs[tab].key].winners">
                <div class="image">
                  <img :src="item.img" alt="">
                </div>
                <div class="name">{{item.name}}</div>
              </div>
            </div>
            <div v-if="$state.drawResult[maxs[tab].key].choose && $state.drawResult[maxs[tab].key].choose.length > 0">
              <div class="my-items_title">我已选择:</div>
              <div class="my-items_list">
                <div class="item" v-for="(item,index) in $state.drawResult[maxs[tab].key].choose">
                  <div class="image">
                    <img :src="item.img" alt="">
                  </div>
                  <div class="name">{{item.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </scroll>
      </div>
    </div>
    <prize-list></prize-list>
  </div>
  <div class="chance">剩余竞猜次数：{{$state.userInfo.chance}}次</div>
  <packet ref="packet"></packet>
  <task @jumpShare="jumpShare"></task>
  <task-popup ref="taskAlert" @closePopup="closePopup" @jumpShare="jumpShare"></task-popup>
  <div class="city">
    <city-list :city.sync="$state.city"></city-list>
  </div>
  <div class="game-ad" v-for="(item,index) in $state.couponList"  v-if="stopDrawTime !== 'end'" @click="$receiveCoupon(item,1)" :style="{'backgroundImage':'url('+$state.brandInfo.ad_img_4+')'}">
    <div class="left">
      <div class="ad-img">
      </div>
      <div  :class="$state.brandInfo.id=='34'?'title1':'title'">{{item.title}}</div>
    </div>
    <div class="right">
      <button :class="item.is_client==1?'got':''" class="get" type="button" name="button">立即领取</button>
    </div>
  </div>
  <video-model ref="video"></video-model>
</div>
</template>

<script>
import scroll from 'common/components/scroll/scroll'
import cityList from 'common/components/city-list/city-list'
import task from '../components/game/task-list'
import taskPopup from '../components/game/task-popup'
import packet from '../components/game/packet'
import prizeList from '../components/game/prize-list'
import videoModel from '../components/game/video-model'
import mixin from '../mixins/mixin'
import {
  gameAuth,
  getTaskInfo,
  getTeams,
  getUserInfo,
  jumpPage,
  gameVote,
  openDraw,
  getCityStore,
  setCityStore
} from '../mixins/functions'
import {
  isAlipay,
  getQueryString
} from 'common/js/util'
export default {
  name: 'game',
  data() {
    return {
      active: 0,
      tab: 0,
      open_0:false,
      open_1:false,
      open_2:false,
      activeList: [],
      title:false,
      lock:false,
      loadlevel:{
        city:0,
        coupon:0
      },
      maxs: [{
        num: 16,
        key: 'first',
        text: '10',
        src: require('../img/16.png')
      }, {
        num: 4,
        key: 'second',
        text: '50',
        src: require('../img/4.png')
      }, {
        num: 1,
        key: 'third',
        text: '100',
        src: require('../img/1.png')
      }]
    }
  },
  watch: {
    serverTime(val) {
      this.getDrawTime()
      this.getStopTime()
      if (this.stopDrawTime === 'end' && !this.title){
        this.$type(1)
        this.title = true
      }
    },
    '$state.city'(newVal,oldVal) {
      setCityStore.call(this)
      //一定有城市信息
      this.loadlevel.city = newVal.cityid
    },
    loadlevel:{
      handler(val){
        //val.city &&
        if(val.coupon){
          const coupon = this.$storejs.get(`${this.$key}Coupon`)||[]
          const is_client = coupon.indexOf(val.coupon)>-1?1:0
          this.$state.couponList = [{
            title:this.$state.brandInfo.ad_coupon_title,
            id:val.coupon,
            is_client:is_client
          }]
        }
      },
      deep:true
    },
    //抽奖结果
    guessTime:{
      handler(val){
        val.map((item,index)=>{
          if(val[index].time === 'end' && !this['open_'+index]){
            this['open_'+index] = true
            this.tabClick(item, index)
          }
        })
      },
      deep:true
    }
  },
  computed:{
    formatTime(){
      const time = this.openTimes[this.tab]
      if(time){
        const t = this.$dayjs(time)
        const $M = (t.$M+1) < 10 ? `0${(t.$M+1)}` : `${(t.$M+1)}`
        const $D = t.$D < 10 ? `0${t.$D}` : `${t.$D}`
        const $H = t.$H < 10 ? `0${t.$H}` : `${t.$H}`
        const $m = t.$m < 10 ? `0${t.$m}` : `${t.$m}`
        const $s = t.$s < 10 ? `0${t.$s}` : `${t.$s}`
        return `${$M}月${$D}日${$H}:${$m}:${$s}开奖`
      }
    }
  },
  created() {
    Promise.all([gameAuth.call(this),this.getTimeInfo()]).then(res => {
      //一定有优惠券信息
      getCityStore.call(this)
      getUserInfo.call(this).then(res=>{
        getTaskInfo.call(this)
        this.loadlevel.coupon = this.$state.brandInfo.ad_coupon_id
        this.tabClick(this.$state.userInfo.first, 0)
        this.autoTab()
      })
      getTeams.call(this)
    })
  },
  mounted() {
    if (isAlipay && window.AlipayJSBridge) {
      ap.onPageResume(res => {
        const refreshTask = this.$storejs.get(`${this.$key}RefreshTask`) || 0
        if (refreshTask) {
          this.$storejs.remove(`${this.$key}RefreshTask`)
          getUserInfo.call(this)
        }
      })
    }
  },
  mixins: [mixin],
  methods: {
    closePopup(){
      this.$nextTick(res=>{
        this.$refs.video.loadplayer(this.$state.brandInfo.ad_video)
      })
    },
    uploadBill() {
      if(this.$state.userInfo.is_checkIn===undefined){
        return
      }
      jumpPage.call(this, {
        pageName: 'intention',
        param: {
          step: this.$state.userInfo.is_checkIn,
          to_game: true,
          not_video:true,
          mid:getQueryString('mid')
        }
      })
    },
    async getMoney(key){
      const res =  await this.$get({
        baseURL: this.$baseURL.cat,
        url: `/activity/${this.$key}/money/send`,
        params: {
          type: key
        }
      })
      if(res.code === 0 ){
        this.$state.drawResult[key].status = true
      }else{
        this.$toast(res.msg)
      }
    },
    jumpShare(){
      if(this.stopDrawTime!=='end'){
        jumpPage.call(this,{ pageName:'share',param:{bid:getQueryString('bid')} })
      }else{
        jumpPage.call(this,{
          pageName:'share',
          param:{
            stopTime:true,
            bid:getQueryString('bid')
          }
        })
      }
    },
    talkClick(){
      if(this.stopDrawTime!=='end'){
        this.$toast(`赛事互动还未开放，开放时间为:\n${this.endTime}` )
      }else{
        jumpPage.call(this,{
          pageName:'message',
          param:{
            mid:getQueryString('mid'),
            bid:getQueryString('bid'),
            not_video:true
          }
        })
      }
    },
    tabClick(item, index) {
      this.$refs.scroll.scrollTo(0, 0)
      this.tab = index
      this.activeList = this.$state.userInfo[this.maxs[this.tab].key]
      this.openDraw()
    },
    //只在开奖的后调用
    async openDraw() {
      const openDrawTime = this.guessTime[this.tab].time;
      if (openDrawTime !== 'end') {
        return
      }
      const hasData = this.$state.drawResult[this.maxs[this.tab].key].winners
      if (hasData && hasData.length === 0) {
        await openDraw.call(this, this.tab)
      }
    },
    async teamsClick(item, index) {
      if (!this.$state.userInfo.chance) {
        this.$toast('你没有竞猜次数了,\n做任务或邀请好友可获取更多次数~')
        return
      }
      if (this.stopDrawTime === 'end') {
        this.$toast(`竞猜已于8月30日23:59:59截止\n16强开奖时间：9月6日00:00\n4强开奖时间：9月12日00:00\n冠军开奖时间：9月16日00:00\n敬请留意！`)
        return
      }
      if(this.lock){
        return
      }
      this.lock = true //防止重复点击
      if (this.activeList.indexOf(item.id) < 0) {
        const list = this.$state.userInfo[this.maxs[this.tab].key]
        if (list.length >= this.maxs[this.tab].num) {
          this.$toast(`当前场次最多可选${this.maxs[this.tab].num}支队伍`)
          this.autoTab()
          return
        }
        const data = {
          type:this.maxs[this.tab].key,
          team_id:item.id
        }
        const res = await gameVote.call(this, data)
        if (res.code === 0) {
          const cnum = res.data.cnum
          this.$state.userInfo.chance--
          list.push(item.id)
          this.activeList = list
          this.$nextTick(res=>{
            this.$refs.packet.openPacket(cnum)
          })
          this.lock = false
          this.autoTab()
        } else {
          this.lock = false
          this.$toast(res.msg)
        }
      }
    },
    autoTab() {
      if (this.stopDrawTime === 'end') {
        return
      }
      const list = this.$state.userInfo[this.maxs[this.tab].key]
      if (list.length >= this.maxs[this.tab].num) {
        const index = this.maxs.findIndex(item => this.$state.userInfo[item.key].length < item.num)
        this.tab = index > -1 ? index : this.tab
        this.activeList = this.$state.userInfo[this.maxs[this.tab].key]
        this.$refs.scroll.scrollTo(0, 0)
      }
    },
  },
  components: {
    scroll,
    task,
    taskPopup,
    cityList,
    packet,
    prizeList,
    videoModel
  }

}
</script>

<style lang="scss">
body{
  background: #a10913;
}
.game {
    background: linear-gradient(to left top,#ea202e, #a10913 30%);
    .lottery-area {
        background: #c30715;
    }
    .box {
        background: #780109;
        border-color: #940a13 #840009 #96020c #780109;
        .team {
            background: #f9f4e1;
            box-shadow: 0 10px 0 #fcc827;
            .choose {
                background: linear-gradient(#fcd127, #fc9827);
                box-shadow: 0 5px 0 #ff4800;
                color: #a00b16;
                &.got {
                    background: linear-gradient(#959595, #777777);
                    box-shadow: 0 5px 0 #989898;
                    color: #fff;
                }
            }

        }
    }
    .tab {
        background: linear-gradient(#f64653, #c30715);
        color: #fff;
        .item {
            &::after {
                border-color: #fff transparent transparent;
            }
        }
        .item:not(:last-child) {
            &::before {
                border-left: 2px solid #8f000b;
            }
        }
        .active {
            background: linear-gradient(#fcc727, #fc9827);
            &::after {
                border-color: #fff transparent transparent;
            }
        }
    }
}

.game {
    padding-bottom: 25px;
}


.top-ad {
    height: 250px;
    background-repeat: no-repeat,no-repeat;
    background-image: url(../img/money1.png),url(../img/money2.png);
    background-position: 55px 65px,600px 120px;
    background-size: 44px 39px,82px 87px;
    text-align: center;
    position: relative;
    .title {
        padding-top: 45px;
        margin: 0 auto;
        display: block;
        width: 494px;
    }
    .time {
        border: 1px solid #fff;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        display: inline-block;
        font-size: 28px;
        color: #fff;
        padding: 0 20px;
    }
    .talk-btn {
        position: absolute;
        bottom: 10px;
        left: 0;
        width: 110px;
        height: 116px;
        border: 0;
        background: url("../img/talk.png") center/contain no-repeat;
    }
    .bill-btn {
        position: absolute;
        bottom: 20px;
        right: 0;
        border: 0;
        height: 40px;
        color: #fff;
        padding: 0 20px;
        font-size: 26px;
        border: 2px solid #fe5e5c;
        border-right: 0;
        display: flex;
        align-items: center;
        box-sizing: content-box;
        background: transparent;
        border-top-left-radius: 21px;
        border-bottom-left-radius: 21px;
        &::after {
            content: '';
            display: inline-block;
            position: absolute;
            width: 0;
            height: 0;
            right: 0;
            top: 15px;
            border-style: solid;
            border-width: 10px 10px 0;
            border-color: #fff transparent transparent;
            transform: rotate(-90deg);
        }
    }
}
.lottery-area {
    width: 720px;
    height: 829px;
    border-radius: 5px;
    margin: 0 auto;
    position: relative;
    .tab {
        display: flex;
        align-items: center;
        .item:not(:last-child) {
            &::before {
                content: '';
                display: inline-block;
                position: absolute;
                top: 20px;
                right: 0;
                width: 0;
                height: 30px;
            }
        }
        .item {
            height: 70px;
            line-height: 70px;
            width: 33.33%;
            text-align: center;
            position: relative;
            &::after {
                content: '';
                display: inline-block;
                position: absolute;
                width: 0;
                height: 0;
                right: 20px;
                top: 30px;
                border-style: solid;
                border-width: 10px 10px 0;
                transform: rotate(-90deg);
            }
        }
        .active {
            &::after {
                transform: rotate(0deg);
                border-width: 10px 10px 0;
            }
        }
    }
    .box {
        width: 690px;
        height: 740px;
        border-width: 60px;
        border-style: solid;
        margin: 0 auto;
        box-sizing: border-box;
        .lottery-result {
            background: #fff;
            width: 650px;
            height: 685px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 95px;
            border-radius: 5px;
            box-shadow: 0 10px 0 #fcc827;
            overflow: hidden;
            .choose {
                background: linear-gradient(#fcd127, #fc9827);
                box-shadow: 0 5px 0 #ff4800;
                color: #a00b16;
                width: 150px;
                height: 36px;
                line-height: 36px;
                border-radius: 18px;
                margin: 10px auto ;
                display: block;
                border: 0;
                font-size: 22px;
                animation: btnScale 1.2s infinite ease-in;
                &.got {
                    background: linear-gradient(#959595, #777777);
                    box-shadow: 0 5px 0 #989898;
                    color: #fff;
                    animation: none;
                }
            }
            .result-area {
                .lottery-title {
                    margin-top: 40px;
                    text-align: center;
                }
                .lottery-text {
                    font-size: 36px;
                    text-align: center;
                    span {
                        font-size: 36px;
                        color: #fd4b3f;
                    }
                }
                .lottery-tip {
                    text-align: center;
                    font-size: 26px;
                    color: #6b6969;
                }
            }
            .no-lottery {
                text-align: center;
                font-size: 38px;
                margin: 40px auto;
            }
            .top {
                .my-items_title,
                .top-items_title {
                    color: #666;
                    text-indent: 1em;
                    margin-top: 20px;
                }
                .my-items_list,
                .top-items_list {
                    overflow: hidden;
                    .item {
                        float: left;
                        width: 25%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        margin: 15px auto;
                        .image {
                            width: 80px;
                            height: 80px;
                            border-radius: 40px;
                            display: flex;
                            align-items: center;
                            overflow: hidden;
                            background: #fff;
                            border-radius: 40px;
                            box-sizing: border-box;
                            margin: 10px auto;
                            img {
                                width: 100%;
                            }
                        }
                    }
                }
            }
            .top_1 {
                width: 450px;
                height: 450px;
                margin: 0 auto;
                // background: url("../img/first.jpg") no-repeat center center;
                // background-size: 500px 500px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                .top1-title {
                    color: #666;
                    text-align: center;
                }
                .top1-img {
                    width: 194px;
                    height: 194px;
                    border-radius: 97px;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    background: #fff;
                    margin: 20px auto;
                    img {
                        width: 100%;
                    }
                }
                .top1-name {
                    font-size: 34px;
                    text-align: center;
                }
            }
        }
        .list {
            position: absolute;
            left: 0;
            top: 70px;
            width: 100%;
            height: 710px;
            padding: 0 15px;
            box-sizing: border-box;
            overflow-y: auto;
            .teams {
                overflow: hidden;
                padding-left: 20px;
                padding-top: 20px;
            }
            .team {
                width: 203px;
                height: 180px;
                border-radius: 10px;
                box-sizing: border-box;
                margin-right: 20px;
                margin-bottom: 30px;
                float: left;
                .info {
                    display: flex;
                    align-items: center;
                    margin-top: 10px;
                    span {
                        font-size: 28px;
                        word-break: keep-all;
                        display: block;
                        height: 70px;
                        display: flex;
                        align-items: center;
                    }
                    .image {
                        width: 60px;
                        height: 60px;
                        margin: 0 5px 0 10px;
                        border-radius: 30px;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        box-sizing: border-box;
                        img {
                            width: 100%;
                        }
                    }
                }
                .choose {
                    width: 130px;
                    height: 36px;
                    line-height: 36px;
                    border-radius: 18px;
                    margin: 10px auto 0;
                    display: block;
                    border: 0;
                    font-size: 22px;
                }
                .num {
                    color: #3297ed;
                    margin: 13px auto 0;
                    height: 34px;
                    line-height: 34px;
                    font-size: 22px;
                    text-align: center;
                }
            }
        }
    }
}
.chance {
    position: relative;
    border: 1px solid #ffff00;
    background: #70060d;
    border-radius: 10px;
    color: #fff;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;
    font-size: 26px;
    padding: 0 10px;
    margin: 22px auto;
    &::after {
        content: '';
        position: absolute;
        bottom: -15px;
        width: 15px;
        height: 15px;
        border: 1px solid #ffff00;
        left: 50%;
        border-top: 0;
        border-left: 0;
        background: #70060d;
        transform: rotate(45deg) translateX(-50%);
    }
}
.game-ad {
    width: 690px;
    height: 122px;
    margin: 25px auto;
    background-color: #ff891c;
    background-repeat: no-repeat;
    background-size: contain;
    display: flex;
    align-items: center;
    .left {
        display: flex;
        align-items: center;
        .ad-img {
            width: 245px;
            height: 122px;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 80%;
                // transform: scaleX(-1);
            }
        }
        .title{
           width: 270px;
           color: #fff;
           font-size: 26px;
           word-break: break-all;
        }
        .title1 {
            width: 220px;
            margin-left:50px;
            color: #fff;
            font-size: 26px;
            word-break: break-all;
        }
    }
    .right {
        width: 175px;
        .get {
            width: 160px;
            height: 50px;
            border: 0;
            border-radius: 25px;
            line-height: 50px;
            display: block;
            margin: 0 auto;
            background: #fdc13c;
            color: #9d1f3d;
            box-shadow: 0 5px 0 #d94e15;
            &.got {
                background: linear-gradient(#959595, #777777);
                box-shadow: 0 5px 0 #989898;
                color: #fff;
            }
        }
    }
}
</style>
